<script setup>
const skills = {
  Frontend: [
    { name: 'HTML & CSS', sub: 'Sass, Bootstrap, Tailwind' },
    { name: 'TypeScript', sub: 'plain JavaScript' },
    { name: 'Vue.js', sub: 'Pinia / Vuex' },
    { name: 'React.js' },
    { name: 'Angular & Ionic' },
  ],
  Testing: [
    { name: 'Cypress', sub: 'E2E testing' },
    { name: 'Playwright', sub: 'E2E testing' },
    { name: 'Manual Testing', sub: 'Functional, Regression, Exploratory' },
    { name: 'Postman', sub: 'API testing' },
    { name: 'CI/CD', sub: 'Jenkins, GitHub Actions' },
  ],
  Backend: [
    { name: 'Node.js / Express', sub: 'with TypeScript' },
    { name: 'Docker' },
    { name: 'MySQL & MongoDB', sub: 'REST, Mongoose' },
    { name: 'REST & GraphQL' },
  ],
}
</script>

<template>
  <section class="skills-section">
    <div class="blob blob-1" />
    <div class="blob blob-2" />

    <div class="skills-header">
      <!-- <span class="label">What I work with</span> -->
      <h2>What I work/worked with</h2>
    </div>

    <div class="skills-grid">
      <div
        v-for="(items, category) in skills"
        :key="category"
        class="skills-card"
      >
        <h3>{{ category }}</h3>
        <ul>
          <li v-for="skill in items" :key="skill.name">
            <span class="skill-name">{{ skill.name }}</span>
            <span v-if="skill.sub" class="skill-sub">{{ skill.sub }}</span>
          </li>
        </ul>
      </div>
    </div>

    <a href="mailto:hello@naeliasalas.com">
      <button class="contact-button">Say hello ✉️</button>
    </a>
  </section>
</template>

<style scoped>
.skills-section {
  position: relative;
  padding: 5rem 2rem;
  max-width: 1200px;
  margin: 0 auto 100px;
  overflow: hidden;
  text-align: center;
}

/* Blobs */
.blob {
  position: absolute;
  border-radius: 50%;
  filter: blur(80px);
  pointer-events: none;
  z-index: 0;
}
.blob-1 {
  width: 400px; height: 400px;
  background: rgba(102, 126, 234, 0.15);
  top: -100px; right: -100px;
}
.blob-2 {
  width: 300px; height: 300px;
  background: rgba(118, 75, 162, 0.15);
  bottom: -50px; left: -50px;
}

/* Header */
.skills-header {
  position: relative;
  z-index: 1;
  margin-bottom: 3rem;
}

.label {
  font-size: 0.8rem;
  letter-spacing: 4px;
  text-transform: uppercase;
  color: #667eea;
  font-weight: 600;
}

h2 {
  font-size: clamp(2rem, 5vw, 3.5rem);
  font-weight: 900;
  letter-spacing: -2px;
  background: linear-gradient(-45deg, #667eea, #764ba2, #a8c0ff, #c471ed);
  background-size: 400% 400%;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  animation: gradientShift 8s ease infinite;
  margin-top: 0.5rem;
}

@keyframes gradientShift {
  0%   { background-position: 0% 50% }
  50%  { background-position: 100% 50% }
  100% { background-position: 0% 50% }
}

/* Grid */
.skills-grid {
  position: relative;
  z-index: 1;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1.5rem;
  margin-bottom: 3rem;
}

/* Card */
.skills-card {
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 20px;
  padding: 2rem 1.5rem;
  text-align: left;
  backdrop-filter: blur(10px);
  transition: transform 0.3s, border-color 0.3s;
}

.skills-card:hover {
  transform: translateY(-4px);
  border-color: rgba(102, 126, 234, 0.4);
}

h3 {
  font-size: 0.8rem;
  letter-spacing: 3px;
  text-transform: uppercase;
  color: #667eea;
  font-weight: 600;
  margin-bottom: 1.5rem;
}

ul { list-style: none; padding: 0; margin: 0 }

li {
  display: flex;
  flex-direction: column;
  margin-bottom: 1.2rem;
}

.skill-name {
  font-size: 1rem;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.85);
}

.skill-sub {
  font-size: 0.8rem;
  color: rgba(255, 255, 255, 0.35);
  margin-top: 2px;
}

/* Button */
.contact-button {
  position: relative;
  z-index: 1;
  padding: 0.9rem 2.5rem;
  border-radius: 50px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  border: none;
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: white;
  box-shadow: 0 10px 30px rgba(102, 126, 234, 0.3);
  transition: all 0.3s;
}

.contact-button:hover {
  transform: translateY(-3px);
  box-shadow: 0 15px 40px rgba(102, 126, 234, 0.4);
}

@media (max-width: 900px) {
  .skills-grid { grid-template-columns: 1fr 1fr }
}

@media (max-width: 600px) {
  .skills-grid { grid-template-columns: 1fr }
}
</style>